import React from 'react';

export default <div className="oneColor" style={{height: '100%'}}>
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 56 56">
    <path fill="#2B328C" fillRule="evenodd" d="M29.756 33.674h3.908V22.326h-3.908v11.348zm-7.42 0h3.908V22.326h-3.908v11.348zM47.341 0H8.659C3.896 0 0 3.896 0 8.659v38.682C0 52.104 3.896 56 8.659 56h38.682C52.104 56 56 52.104 56 47.341V8.659C56 3.896 52.104 0 47.341 0z"/>
  </svg>
</div>;
